import { memo } from 'react';
import { Checkbox } from 'antd';
import { useUpdateChildSummaryPlaceholderMutation } from '@/services/child-api';

const SummaryPlaceholder = ({ childId, defaultValue, disabled }) => {
  const [updatePlaceholder] = useUpdateChildSummaryPlaceholderMutation();

  const onChange = (e) => {
    updatePlaceholder({ childId, value: e.target.checked });
  };

  return (
    <Checkbox defaultChecked={defaultValue} onChange={onChange} disabled={disabled}>
      Summary is placeholder
    </Checkbox>
  );
};

export default memo(SummaryPlaceholder);
